import { DeviceDashboardActions, DeviceDashboardActionTypes } from './device-dashboard.actions';
import {
  DashboardAlertDevicesInterface,
  DashboardDeviceInterface,
  DashboardKpiInterface,
  DashboardListInterface,
} from '../../view/device-dashboard/device-dashboard.model';


export interface DeviceDashboardState {
  lists: DashboardListInterface[];
  activeListId: number | null;
  devices: DashboardDeviceInterface[];
  kpis: DashboardKpiInterface;
  alertDevices: DashboardAlertDevicesInterface[];
  loading: boolean;
  searchedDevices: any[];
  sharedLinkToken: string | null;
  errors: any[];
}

export const initialState: DeviceDashboardState = {
  lists: [],
  activeListId: null,
  devices: [],
  kpis: { active: 0, acknowledged: 0, passive: 0, disabled: 0 },
  alertDevices: [],
  loading: false,
  searchedDevices: [],
  sharedLinkToken: null,
  errors: [],
};

export function deviceDashboardReducer(state = initialState, action: DeviceDashboardActions): DeviceDashboardState {
  switch (action.type) {
    case DeviceDashboardActionTypes.LoadListsSuccess:
      return { ...state, lists: action.payload, activeListId: action.payload[0]?.id || null };
    case DeviceDashboardActionTypes.CreateListSuccess:
      return { ...state, activeListId: action.payload.id };
    case DeviceDashboardActionTypes.LoadDevicesSuccess:
      return { ...state, devices: action.payload };
    case DeviceDashboardActionTypes.LoadAlertCountsSuccess:
      return { ...state, kpis: action.payload };
    case DeviceDashboardActionTypes.LoadAlertDevicesSuccess:
      return { ...state, alertDevices: action.payload };
    case DeviceDashboardActionTypes.FetchError:
      return { ...state, errors: [...state.errors, action.payload] };
    case DeviceDashboardActionTypes.SearchAllDevicesSuccess:
      return { ...state, searchedDevices: action.payload };
    case DeviceDashboardActionTypes.UpdateListSuccess:
      const updatedLists = state.lists.map((list) => (list.id === action.payload.id ? action.payload : list));
      return { ...state, lists: updatedLists };
    case DeviceDashboardActionTypes.GenerateSharedLink:
      return { ...state, sharedLinkToken: null };
    case DeviceDashboardActionTypes.GenerateSharedLinkSuccess:
      return { ...state, sharedLinkToken: action.payload };

    default:
      return state;
  }
}
